import { cloneElement } from 'react';
import AC from '../AccessControl';
import styles from './FeatureCard.module.scss';
const FeatureCard = ({
  image,
  title,
  desc,
  url,
  size = "default"
}) => <div className={styles["featured-card-container"]} data-sentry-component="FeatureCard" data-sentry-source-file="FeatureCard.jsx">
    <div className={`${styles['featured-image']} ${styles[size]}`}>
      <AC.Link href={url} label={image} ifCant={<span children={cloneElement(image, {
      style: {
        filter: 'grayscale(1)'
      }
    })} />} data-sentry-element="unknown" data-sentry-source-file="FeatureCard.jsx" />
    </div>
    <div className={styles["featured-title"]}>{title}</div>
    <div className={styles["featured-description"]}>{desc}</div>
  </div>;
export default FeatureCard;